import FetchHelpers from 'utils/FetchHelpers';
import { apiRoutes } from 'routes';

export default {
  index() {
    const url = apiRoutes.loanOfficerBidRequestsPath();

    return FetchHelpers.get(url);
  },
  show(bidRequestId) {
    const url = apiRoutes.loanOfficerBidRequestPath(bidRequestId);

    return FetchHelpers.get(url);
  },
  post(params) {
    const url = apiRoutes.loanOfficerBidsPath();

    return FetchHelpers.post(url, params);
  },
};



// WEBPACK FOOTER //
// ./src/repositories/loanOfficer/BidRequestRepository.js